export default __webpack_public_path__ + "static/media/image1.9cce8ee3.jpg";